import { Routes, Route } from "react-router-dom";
import { Contacts } from "../pages/Contacts";
import { HomePage } from "../pages/HomePage/HomePage";
import { ProjectsPage } from "../pages/Projects";
import { Services } from "../pages/Servicos";
import { WhoIAmPage } from "../pages/WhoIAm";

export const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/quem-sou" element={<WhoIAmPage />} />
      <Route path="/servicos" element={<Services />} />
      <Route path="/projetos" element={<ProjectsPage />} />
      <Route path="/contatos" element={<Contacts />} />
    </Routes>
  );
};
